import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { PROFILE } from "../data/content";

export const Footer = ({ onTop }) => (
  <footer data-testid="footer" className="relative border-t border-white/10 px-5 py-12 md:px-12">
    <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-8 md:flex-row">
      <div className="flex items-center gap-3">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 12, ease: "linear" }}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-electric/40"
        >
          <span className="font-display text-lg font-bold text-electric">B</span>
        </motion.div>
        <span className="font-heading text-lg font-semibold text-cream">{PROFILE.name}</span>
      </div>

      <p className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/40">
        © {new Date().getFullYear()} · Designed & developed with intent
      </p>

      <button
        data-testid="back-to-top"
        onClick={onTop}
        className="group flex items-center gap-2 font-mono text-[0.7rem] uppercase tracking-wider text-white/60 transition-colors hover:text-electric"
      >
        Back to top
        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 transition-transform group-hover:-translate-y-1 group-hover:border-electric/50">
          <ArrowUp size={15} />
        </span>
      </button>
    </div>
  </footer>
);
